<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
.el-card.is-always-shadow {
  box-shadow: 0px 3px 6px rgb(204 217 233 / 70%) !important;
}

.container_box {
  background: url("assets/imgs/bg.png");
  /* padding-top: 30px; */
  /* padding-bottom: 43px; */
}
</style>
